import React, { useEffect } from "react";
import { useSet, useDetail } from "seed/gql";
import { SET_FLOW } from "seed/gql/queries";
import { Loading } from "seed/helpers";
import View from "components/presentation/settings/CustomViews.view";

function CustomViews({
  flow,
  chat,
  refreshFlow,
  closeModal = () => { },
}) {

  const reqFlow = useDetail(`{
    flow {
      presentationSettings
    }
  }`, flow.id);

  const [callSetFlow] = useSet(SET_FLOW, {
    onCompleted: (data) => {
      refreshFlow();
      closeModal();
    }
  });

  useEffect(() => {
      reqFlow.refetch();
    }, []);

  const onSubmit = (values) => {
    if (values.error) delete values.error;
    callSetFlow({ id: flow.id, presentationSettings: values });
  }

  const { presentationSettings = {} } = reqFlow.data?.flow || {};
  if (reqFlow.loading) return <Loading />;

  return <View
    presentationSettings={presentationSettings}
    onSubmit={onSubmit}
  />;

}

export default CustomViews;